<div class="saml-settings h-full overflow-hidden">
  <ts-page-header [displaySeparationBorder]="true">
    <span page-header-title class="font-ts-header-title text-ts-header-title">SAML Settings</span>
    <div class="flex justify-end align-center gap-2" page-header-action-buttons>
      <a href="https://help.termsheet.com/single-sign-on" target="_blank">Help</a>
    </div>
  </ts-page-header>

  <div class="general-settings__main bg-white h-ts-page-content p-ts-page-content overflow-auto">
    <div class="general-settings__form">
      <form class="flex flex-col justify-start items-center w-90" [formGroup]="samlSettingsForm">
        <input formControlName="id" type="hidden" />
        <fieldset [formGroupName]="'saml_setting'" class="w-full">
          <input formControlName="id" type="hidden" />
          <ts-input
            label="Identity Provider Id*"
            formControlName="idp_entity_id"
            placeholder="Identity Provider Id"
          ></ts-input>
          <ts-input label="Login Url*" formControlName="idp_sso_target_url" placeholder="Login Url"></ts-input>
          <mat-form-field class="treo-mat-textarea w-full">
            <mat-label>Base64 Public Certificate</mat-label>
            <textarea
              matInput
              treoAutogrow
              [rows]="5"
              formControlName="idp_cert"
              [placeholder]="'Please paste your base64 encoded cert here...'"
              [spellcheck]="false"
            ></textarea>
          </mat-form-field>
          <ts-input label="SP Entity Id" formControlName="sp_entity_id" placeholder="SP Entity Id"></ts-input>
          <ol>
            <li>
              <mat-checkbox [color]="'primary'" formControlName="active"> Active </mat-checkbox>
            </li>
            <li>
              <mat-checkbox [color]="'primary'" formControlName="required"> Required </mat-checkbox>
            </li>
          </ol>
        </fieldset>

        <!-- We are hiding this feature for now. PM is figuring out where to put it -->
        <button
          mat-flat-button
          class="mt-10"
          [color]="'primary'"
          [disabled]="samlSettingsForm.invalid || samlSettingsForm.pristine"
          (click)="updateSettings()"
        >
          Save
        </button>
      </form>
    </div>
  </div>
</div>
